import { useSelector, shallowEqual } from 'react-redux';

export const useFeatureFlags = () =>
  useSelector((state: any) => state.featureFlags, shallowEqual);
